import React from 'react'
import { Box, Button, Card, CardContent, Grid, Typography } from '@material-ui/core'

import { Generic } from '../../api/models'

interface LocationCardProps {
  item: Generic
  onFound?: () => void
}

export const LocationCard = (props: LocationCardProps) => {
  const { item, onFound } = props
  const Icon = item?.object?.icon
  return (
    <Card>
      <CardContent>
        <Typography>
          <Icon /> {item.object.typeDisplay}
        </Typography>
        <Grid container spacing={10}>
          <Grid item container>
            <Grid item container spacing={6} xs={12}>
              <Grid item>
                <Box fontWeight="bold">SquID:</Box>
              </Grid>
              <Grid item>{item.id}</Grid>
            </Grid>
            <Grid item container spacing={6} xs={12}>
              <Grid item>
                <Box fontWeight="bold">Path:</Box>
              </Grid>
              <Grid item>{item.object.path}</Grid>
            </Grid>
            <Grid item container spacing={6} xs={12}>
              <Grid item>
                <Box fontWeight="bold">Short:</Box>
              </Grid>
              <Grid item>{item.object.shortPath}</Grid>
            </Grid>
          </Grid>
          <Grid item container>
            <Grid item spacing={6} xs={12}>
              <Typography variant="h5">
                Quick Actions
              </Typography>
            </Grid>
            <Grid item spacing={8} xs={12}>
              <Button variant="outlined" color="primary" onClick={() => onFound?.()}>
                Found Untracked Inventory
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}
